// StartMenu UI Component
import { socket } from "../socket";
import { useEffect, useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import '../stylesheets/Menus.css';

export default function StartMenu({ onStartGame, onJoinClick }) {
    const [showBugModal, setShowBugModal] = useState(false);
    const [bugDescription, setBugDescription] = useState("");
    const [isSubmittingBug, setIsSubmittingBug] = useState(false);
    const [bugSubmitError, setBugSubmitError] = useState("");
    const [bugSubmitted, setBugSubmitted] = useState(false);

    useEffect(() => {
        socket.on("serverMessage", (msg) => {
            console.log("Message from server:", msg);
        });

        socket.on("gameJoined", ({ gameId, state }) => {
            console.log("Joined game:", gameId, state);
        });

        socket.on("stateUpdate", ({ state }) => {
            console.log("State update:", state);
        });

        socket.on("error", (err) => {
            console.error("Server error:", err);
            alert(`Error: ${err.message}`);
        });

        return () => {
            socket.off("serverMessage");
            socket.off("gameJoined");
            socket.off("stateUpdate");
            socket.off("error");
        };
    }, []);

    const handleOpenBugModal = () => {
        setBugSubmitError("");
        setBugSubmitted(false);
        setShowBugModal(true);
    };

    const handleCloseBugModal = () => {
        if (isSubmittingBug) return;

        setShowBugModal(false);
        setBugDescription("");
        setBugSubmitError("");
        setBugSubmitted(false);
    };

    const handleSubmitBug = async (event) => {
        event.preventDefault();

        const trimmedDescription = bugDescription.trim();

        if (!trimmedDescription) {
            setBugSubmitError("Please describe the bug you encountered.");
            return;
        }

        try {
            setIsSubmittingBug(true);
            setBugSubmitError("");

            await addDoc(collection(db, "callItOutFeedback"), {
                type: "GLITCH",
                description: trimmedDescription,
                gameId: null,
                pageUrl: window.location.href,
                userAgent: navigator.userAgent,
                createdAt: serverTimestamp(),
            });
            setBugDescription("");
            setBugSubmitted(true);

        } catch (error) {
            console.error("Failed to submit bug report:", error);
            setBugSubmitError(
                "Could not submit your bug report. Please try again."
            );
        } finally {
            setIsSubmittingBug(false);
        }
    };

    return (
        <>
            <div className="start-menu-container">
                <img
                    src="/assets/CIOL_Title.png"
                    alt="Call It Out Loud"
                    className="start-menu-logo"
                />

                <button
                    onClick={onStartGame}
                    className="start-menu-button"
                >
                    Start Game
                </button>

                <button
                    onClick={onJoinClick}
                    className="start-menu-button"
                >
                    Join Game
                </button>

                <button
                    type="button"
                    className="bug-report-button"
                    onClick={handleOpenBugModal}
                    aria-label="Report a bug"
                    title="Report a bug"
                >
                    🐞
                </button>
            </div>

            {showBugModal && (
                <div
                    className="bug-modal-overlay"
                    onMouseDown={handleCloseBugModal}
                >
                    <div
                        className="bug-modal"
                        onMouseDown={(event) => event.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="bug-modal-close"
                            onClick={handleCloseBugModal}
                            aria-label="Close bug report"
                        >
                            ×
                        </button>

                        {!bugSubmitted ? (
                            <>
                                <h2>Report a Bug</h2>

                                <p>
                                    Found something that isn't working correctly?
                                    Let us know what happened.
                                </p>

                                <form onSubmit={handleSubmitBug}>
                                    <label htmlFor="bug-description">
                                        What happened?
                                    </label>

                                    <textarea
                                        id="bug-description"
                                        value={bugDescription}
                                        onChange={(event) =>
                                            setBugDescription(event.target.value)
                                        }
                                        placeholder="Describe what happened and what you were doing when the bug occurred..."
                                        maxLength={1000}
                                        rows={6}
                                    />

                                    {bugSubmitError && (
                                        <p className="bug-modal-error">
                                            {bugSubmitError}
                                        </p>
                                    )}

                                    <button
                                        type="submit"
                                        className="bug-modal-submit"
                                        disabled={isSubmittingBug}
                                    >
                                        {isSubmittingBug
                                            ? "Submitting..."
                                            : "Submit Bug Report"}
                                    </button>
                                </form>
                            </>
                        ) : (
                            <div className="bug-modal-success">
                                <h2>Thank You!</h2>

                                <p>
                                    Your bug report has been submitted.
                                </p>

                                <button
                                    type="button"
                                    className="bug-modal-submit"
                                    onClick={handleCloseBugModal}
                                >
                                    Close
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}